<template>
  <div>
    <!-- 弹窗-添加/修改 -->
    <simple-modal 
      ref    ="modal"
      :title ="title"
      :right ="true"
      :middle="true"
      @submit="submit"
    >
      <template slot="body">
        <!--  -->
        <div>
          <common-form-item 
            :labelweight="165"
            v-for="item in formItem_name" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
          <!-- <p class="form-info">{{$I18n("sn_number_info")}}</p> -->

          <common-form-item 
            :labelweight="165"
            v-for="item in formItem" 
            v-model="formData.Form[item.keys]" 
            :error="formData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass } from "@/common/tools.js";
export default {
  name: "modal-device",
  props:["organi"],
  data() {
    let formData = new FormClass({ // 弹窗-表单数据
      // 设备账号
      dev_user  : {
        init : "",
        check: "required"
      },
      // Uid
      dev_umid  : {
        init : "",
        check: function(val){
          return !val || val.length > 30
        },
        errormsg: this.$I18n("pls_input_sn_num"),
      },
      // 设备名称
      node_name : {
        init : "",
        check: "smallstr"
      },
      // 设备密码
      dev_passwd: {
        init : "",
        check: "required"
      },
      loc_id    : "",
    });
    formData.ErrorPriority = ["dev_umid"]
    return{
      isHttps : window.location.protocol === "https:",
      title:"",
      type :"add",
      // 提交内容固定值
      constData: {
        dev_stream_no  : 1, // 固定值
        vendor_id      : 1009,  // 固定值
        conn_mode      : 2, // 固定值
        dev_type       : 1,// 固定值：1
        only_umid      : 1,// 固定值
        parent_node_id : "0", // 固定值
        dev_ch_no      : 1, // 固定值
        node_type      : 2,// 固定值
      },
      formData,
      area: [],
    }
  },
  mounted(){
    this.$api.g_DevZone({
      home_id: this.organi,
      page_no: 1,
      page_size: 9999,
    })
      .then(res => {
        this.area = res.data;
        if(res.data.length > 0){
          this.formData.SetInit(res.data[0].id, "loc_id")
        }
      })
      .catch(() => {})
  },
  computed: {
    formItem_name(){
      return [
        {
          label  : this.$I18n("sn_num"),
          keys     : "dev_umid",
          type     : "input",
          check    : true,
          required : true,
          placeholder: this.$I18n("pls_input"),
        },
      ]
    },
    formItem(){
      return[{
          label  : this.$I18n("equip_name"),
          keys     : "dev_user",
          type     : "input",
          check    : true,
          required : true,
          placeholder: this.$I18n("pls_input"),
        },{
          label  : this.$I18n("equip_area"),
          keys     : "loc_id",
          type     : "select",
          options  : this.area.map(i => {
            return {
              id: i.id,
              name: i.name,
            }
          }),
        },{
          label  : this.$I18n("dev_name"),
          keys     : "node_name",
          type     : "input",
          check    : true,
          required : true,
          placeholder: this.$I18n("pls_input"),
        },{
          label  : this.$I18n("dev_pass"),
          keys     : "dev_passwd",
          type     : "input",
          check    : true,
          required : true,
          placeholder: this.$I18n("pls_input"),
        },
      ]
    },
  },
  methods:{
    /*
      type : add | edit | del
      data : 表单基础数据
    */
    open(type, data){
      this.type = type;
      this.depts = this.UserInfo.depts;
      if(type === "add"){
        this.$refs.modal.open();
        this.formData.Reset();
        this.title = this.$I18n("add_dept")

      } else if(type === "edit"){
        this.$refs.modal.open();
        this.formData.Update(data);
        this.title = this.$I18n("edit_dept")
      
      } else if(type === "del"){
        this.formData.Update(data);
        this.$confirm(this.$I18n("conf_del"), this.$I18n("del_dept"), {
          confirmButtonText: this.$I18n("sure"),
          cancelButtonText : this.$I18n("cancle"),
          type: 'warning'
        }).then(() => {
          this.submit();
        }).catch(() => { })
      }
    },
    submit(){
      if(this.type === "add"){
        this.add();
      } else if(this.type === "edit"){
        this.edit();
      } else if(this.type === "del"){
        this.del();
      }
    },
    // 调用父组件传递的close方法
    close(){
      this.$refs.modal.close();
      if(this.$listeners["close"]){
       this.$emit('close', this.type);
      }
    },
    add(){
      this.formData.Form.dev_umid = this.formData.Form.dev_umid.trim()
      if(!this.formData.Form.dev_user){
        this.formData.Form.dev_user = this.formData.Form.dev_umid
      }

      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.__sendNumApi(232, window.appConfig.umeye_api(this.isHttps, localStorage.umh_host), {
        ...this.formData.Form,
        ...this.constData,
      },"", localStorage.acc_token)
        .then(res => {
          if(res.h.e !== 200){
            if(res.h.e === 409){
              this.$errorMsg(this.$I18n("dev_exist"));
              return
            }
            throw res
          }
          this.$successMsg(this.$I18n("add_success"));
          this.close();
        })
        .catch(res => {
          console.error(res)
          this.$errorMsg(this.$I18n("add_fail"));
        })
    },
    edit(){
      this.formData.Form.dev_umid = this.formData.Form.dev_umid.trim()
      if(!this.formData.Form.dev_user){
        this.formData.Form.dev_user = this.formData.Form.dev_umid
      }
      if(this.formData.Check()){
        this.$errorMsg(this.formData.ErrMsg ?this.formData.ErrMsg :this.$I18n("pls_check_verify"))
        return 
      }
      this.$api.__sendNumApi(234, window.appConfig.umeye_api(this.isHttps, localStorage.umh_host), {
        ...this.formData.Form,
        ...this.constData,
      },"", localStorage.acc_token)
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          this.$successMsg(this.$I18n("edit_success"));
          this.close();
        })
        .catch(res => {
          console.error(res)
          this.$errorMsg(this.$I18n("edit_fail"));
        })
    },
    del(){
      this.$api.__sendNumApi(233, window.appConfig.umeye_api(this.isHttps, localStorage.umh_host), {
        ...this.formData.Form,
        ...this.constData,
      },"", localStorage.acc_token)
        .then(res => {
          if(res.h.e !== 200){
            throw res
          }
          this.$successMsg(this.$I18n("delete_success"));
          this.close();
        })
        .catch(res => {
          console.error(res)
          this.$errorMsg(this.$I18n("delete_fail"));
        })
    },
  },
}
</script>

<style scoped>
  .form-info{
    color: #FD0000;
    padding-left: 165px;
    font-size: 14px;
}
</style>